import React, { useState } from "react";
import { MdDelete, MdDownload, MdEdit, MdSearch } from "react-icons/md";
import { TiPlus } from "react-icons/ti";
import { toast } from "react-toastify";
import { jsonToXlsx } from "../../../Services/commonHelper.js";
import { useLocation } from "react-router-dom";
import useTableApi from "../../../Components/TableApi.js";
import ConfirmModal from "../../../Components/Modals/ConfirmModal";
import { deleteSkillBenefitById, getSkillBenefitsById } from "../../../Services/SkillService.js";
import { deleteTodoById } from "../../../Services/MasterService.js";
import AddSkillBenefit from "../../../Components/Modals/AddSkillBenefit.js";


const SkillBenefits = () => {
    const [openAddModal, setOpenAddModal] = useState({
        status: false,
        data: ""
    });
    const [deleteModal, setDeleteModal] = useState({
        status: false,
        data: ""
    });
    const location = useLocation();
    const data = location?.state;

    const getRequest = async () => {
        let response = await getSkillBenefitsById(data?.id);
        return response;
    };

    const { pageIndex, changeFilterOptions, isLoading, recordsInfo } = useTableApi(getRequest, true);

    const handleSearch = (e) => {
        if (e.keyCode == 13 || !e.target.value?.length) {
            e.preventDefault();
            changeFilterOptions({ search: e.target.value })
        }
    };

    const handleExport = async (e) => {
        e.preventDefault();
        if (recordsInfo?.totalRecords > 0) {
            jsonToXlsx(recordsInfo?.data, `skill_benefits_${data?.name}`);
        } else {
            toast.error("No records to export")
        }
    };

    const handleDelete = async () => {
        if (deleteTodoById) {
            const { ok, message } = await deleteSkillBenefitById({ id: deleteModal?.data?.id });
            if (ok) {
                toast.success(message || "Success");
                changeFilterOptions();
            }
        }
        setDeleteModal();
    };

    const handleCloseAddModal = (apiCall = false) => {
        setOpenAddModal();
        apiCall && changeFilterOptions();
    };

    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Color",
            value: "color",
            renderValue: (value) => {
                return (
                    <svg width="20" height="20" >
                        <rect width="100" height="100" fill={value} />
                    </svg>
                )
            }
        },
        {
            label: "Icon",
            value: "icon",
            renderValue: (value) => {
                return (
                    value ?
                        <img width={70} src={value} alt="..." class="img-thumbnail" />
                        :
                        <td>{"-"}</td>
                )
            }
        }
    ];

    return (
        <div className="content container-fluid">
            <div className="page-header">
                <div className="row align-items-center">
                    <div className="col">
                        <h3 className="page-title">{`Skill Benefits: ${data?.name}`}</h3>
                    </div>
                    <div className="col-auto">
                        <span className="btn btn-primary me-1" onClick={() => setOpenAddModal({ data: { skill_id: data?.id }, status: true })}>
                            <TiPlus size={24} />
                        </span>
                        <a href="add-Influencer.html" className="btn btn-primary me-1" onClick={(e) => handleExport(e)}>
                            <MdDownload size={24} />
                        </a>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <div className="card card-table">
                        <div className="card-body">
                            <div className="table-responsive">
                                <div className="tbl-search">
                                    <input type="text" onKeyUp={handleSearch} className="form-control" placeholder="Search here..."
                                    />
                                    <button className=" mt-3 mx-2 btn" type="submit">
                                        <MdSearch />
                                    </button>
                                </div>
                                {isLoading ?
                                    <div class=" mt-4 d-flex justify-content-center">
                                        <div class="spinner-border" role="status" />
                                    </div>
                                    :
                                    Boolean(recordsInfo?.data?.length) &&
                                    <table className="table table-striped table-bordered ">
                                        <thead className="thead">
                                            <tr>
                                                <th>Serial No</th>
                                                {columns.map((item, index) => <th>{item?.label}</th>)}
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <>
                                                {/* {recordsInfo?.data?.slice(pageIndex * 10)?.map((value, index) => ( */}
                                                {recordsInfo?.data?.map((value, index) => (
                                                    <tr>
                                                        <td>{index + 1 + (pageIndex * 10)}</td>
                                                        {columns.map((item, index) => <td>{item.renderValue ? item.renderValue(value[item?.value]) : value[item?.value] || "-"}</td>)}
                                                        <td className="text-center">
                                                            <span className="btn btn-sm btn-white text-success me-2" onClick={() => setOpenAddModal({ data: value, status: true })}>
                                                                <MdEdit className="me-1" /> Edit
                                                            </span>
                                                            <span className="btn btn-sm btn-white text-danger me-2" onClick={() => setDeleteModal({ data: value, status: true })}>
                                                                <MdDelete className="me-1" />
                                                                Delete
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>
                                        </tbody>
                                    </table>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {openAddModal?.status &&
                <AddSkillBenefit
                    data={openAddModal}
                    onClose={() => handleCloseAddModal()}
                    onCloseWithApi={() => handleCloseAddModal(true)}
                />}
            {deleteModal?.status &&
                <ConfirmModal
                    onClose={setDeleteModal}
                    message="Are you sure want to delete this item."
                    title="Alert!"
                    handleDelete={handleDelete}
                />}
        </div >
    );
};

export default SkillBenefits;